import ListStore from '@/store/core/ListStore';
import { action, computed } from 'mobx';
import services from '@/api/services';
import { numGroup } from '@/utils/numbers';

export default class TaxpayerDetailsStore extends ListStore {
  @computed get processedData() {
    if (!this.data) return;
    const details = (Object.entries(this.data) as [string, number][]).map(
      ([key, value]) => [key, numGroup(value)],
    );
    return Object.fromEntries(details);
  }

  @action.bound async fetch({ id, year }: { id: string; year: string }) {
    this.isFetching = true;
    try {
      const { data } = await services.platforms.getTaxpayerDetails({
        id,
        year,
      });
      this.data = data;
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
